<div *ngIf="isLoading" class="overlay"></div>
<div *ngIf="isLoading" class="loader"></div>
<div class="example-inner">
  <div class="container">
    <div class="header">
      <button mat-raised-button 
            color="primary" 
            class="dashboard-button" 
            routerLink="/products">
      <mat-icon>dashboard</mat-icon>
      <span>Stock Dashboard</span>
      </button>
      <h1 class="page-title" >Stock Count</h1>
  </div>

  <div style="padding: 10px;">
  <button mat-raised-button 
            color="primary" 
            [disabled]="!hasChanges || isLoading"
            (click)="saveAllChanges()"
            class="save-button">
      <mat-icon>save</mat-icon>
      Save All Changes
    </button>


  </div>

    <div class="products-grid">
      <div class="column">
        <div *ngFor="let product of leftColumnProducts" class="product-row">
          <mat-card>
            <div class="product-content">
              <mat-form-field appearance="outline">
                <mat-label>Title</mat-label>
                <input matInput
                       [(ngModel)]="product.title"
                       (ngModelChange)="onFieldChange(product)">
              </mat-form-field>

              <!-- <mat-form-field appearance="outline" class="stock-field">
                <mat-label>Stock Before Save</mat-label>
                <div class="title-label">{{ product.stockCount }}</div>
              </mat-form-field> -->

              <!-- <mat-form-field appearance="outline" class="stock-field">
                <mat-label>Stock Before Save</mat-label>
                <input matInput
                       type="number"
                       [value]="product.stockCount"
                       readonly>
              </mat-form-field> -->
  
              <mat-form-field appearance="outline" class="stock-field" [class.changed]="product.changed">
                <mat-label>Stock</mat-label>
                <input matInput
                        #stockInput
                       type="number"
                       [(ngModel)]="product.stockCount"
                       (ngModelChange)="$event && ($any(stockInput).style.backgroundColor='#fff3cd') && onFieldChange(product)">
              </mat-form-field>
            </div>
          </mat-card>
        </div>
      </div>
  
      <div class="column">
        <div *ngFor="let product of rightColumnProducts" class="product-row">
          <mat-card>
            <div class="product-content">
              <mat-form-field appearance="outline">
                <mat-label>Title</mat-label>
                <input matInput
                       [(ngModel)]="product.title"
                       (ngModelChange)="onFieldChange(product)">
              </mat-form-field>

              <!-- <mat-form-field appearance="outline" class="stock-field">
                <mat-label>Stock Before Save</mat-label>
                <div class="title-label">{{ product.stockCount }}</div>
              </mat-form-field> -->

              <!-- <mat-form-field appearance="outline" class="stock-field">
                <mat-label>Stock Before Save</mat-label>
                <input matInput
                       type="number"
                       [value]="product.stockCount"
                       readonly>
              </mat-form-field> -->
  
              <mat-form-field appearance="outline" class="stock-field" [class.changed]="product.changed">
                <mat-label>Stock</mat-label>
                <input matInput
                #stockInput
                type="number"
                [(ngModel)]="product.stockCount"
                (ngModelChange)="$event && ($any(stockInput).style.backgroundColor='#fff3cd') && onFieldChange(product)">
              </mat-form-field>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  
    <mat-spinner *ngIf="isLoading" diameter="50" class="loading-spinner"></mat-spinner>
  </div>
